/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RoutesAliases {
  ALETERAR_SENHA_FRAGMENT = 'aleterar-senha-fragment',
  ALTERAR_BENEF_RELATORIO_FRAGMENT = 'alterar-benef-relatorio-fragment',
  ALTERAR_BENEF_RELATORIO_ROUTE = 'alterar-benef-relatorio-route',
  ALTERAR_DATA_ADMISSAO_FRAGMENT = 'alterar-data-admissao-fragment',
  ALTERAR_DATA_ADMISSAO_ROUTE = 'alterar-data-admissao-route',
  ALTERAR_LOCALIZACAO_FRAGMENT = 'alterar-localizacao-fragment',
  ALTERAR_LOCALIZACAO_ROUTE = 'alterar-localizacao-route',
  ALTERAR_MATRICULA_FRAGMENT = 'alterar-matricula-fragment',
  ALTERAR_MATRICULA_ROUTE = 'alterar-matricula-route',
  ALTERAR_SENHA_ROUTE = 'alterar-senha-route',
  ALTERAR_VINCULO_FRAGMENT = 'alterar-vinculo-fragment',
  ALTERAR_VINCULO_ROUTE = 'alterar-vinculo-route',
  ASSIGN_TERMO_USO_FRAGMENT = 'assign-termo-uso-fragment',
  ASSIGN_TERMO_USO_ROUTE = 'assign-termo-uso-route',
  AVISO_PRIVACIDADE_FRAGMENT = 'aviso-privacidade-fragment',
  AVISO_PRIVACIDADE_ROUTE = 'aviso-privacidade-route',
  BENEFICIARIO_DOSSIE_FRAGMENT = 'beneficiario-dossie-fragment',
  BENEFICIARIO_DOSSIE_ROUTE = 'beneficiario-dossie-route',
  BENEFICIARY_CHANGE_FRAGMENT = 'beneficiary-change-fragment',
  BENEFICIARY_CHANGE_ROUTE = 'beneficiary-change-route',
  BENEFICIARY_FRAGMENT = 'beneficiary-fragment',
  BREADCRUMB_0 = 'breadcrumb-0',
  CONFIRMAR_CARTAO_FRAGMENT = 'confirmar-cartao-fragment',
  CONFIRMAR_CARTAO_ROUTE = 'confirmar-cartao-route',
  CONFIRMAR_MIGRACAO_CONTRATO = 'confirmar-migracao-contrato',
  CONSULTAR_ALTERACAO_PRODUTO_FRAGMENT = 'consultar-alteracao-produto-fragment',
  CONSULTAR_ALTERACAO_PRODUTO_ROUTE = 'consultar-alteracao-produto-route',
  CONSULTAR_ALTERACOES_VINCULO_FRAGMENT = 'consultar-alteracoes-vinculo-fragment',
  CONSULTAR_ALTERACOES_VINCULO_ROUTE = 'consultar-alteracoes-vinculo-route',
  CONSULTAR_CARTAO_FRAGMENT = 'consultar-cartao-fragment',
  CONSULTAR_CARTAO_ROUTE = 'consultar-cartao-route',
  CONSULTAR_COMPARTILHAMENTO_RISCO_FRAGMENT = 'consultar-compartilhamento-risco-fragment',
  CONSULTAR_COMPARTILHAMENTO_RISCO_ROUTE = 'consultar-compartilhamento-risco-route',
  CONSULTAR_STATUS_VIA_FRAGMENT = 'consultar-status-via-fragment',
  CONSULTAR_STATUS_VIA_ROUTE = 'consultar-status-via-route',
  DADOS_PESSOAIS_DETALHES = 'dados-pessoais-detalhes',
  DADOS_PESSOAIS_DETALHES_FRAGMENT = 'dados-pessoais-detalhes-fragment',
  DADOS_PESSOAIS_FRAGMENT = 'dados-pessoais-fragment',
  DASHBOARD_FRAGMENT = 'dashboard-fragment',
  DASHBOARD_HISTORICO_ALT_CADASTRAL = 'dashboard-historico-alt-cadastral',
  DASHBOARD_ROUTE = 'dashboard-route',
  DINAMICO_FRAGMENT = 'dinamico-fragment',
  DINAMICO_ROUTE = 'dinamico-route',
  FINALIZAR_REPASSE_FRAGMENT = 'finalizar-repasse-fragment',
  FINALIZAR_REPASSE_ROUTE = 'finalizar-repasse-route',
  FRAGMENT_ALTERACAO_LOCALIZACAO = 'fragment-alteracao-localizacao',
  FRAGMENT_ALTERAR_SUBESTIPULANTE = 'fragment-alterar-subestipulante',
  FRAGMENT_BENEF_DETALHES = 'fragment-benef-detalhes',
  FRAGMENT_BENEF_INCONSISTENCIA_SIB = 'fragment-benef-inconsistencia-sib',
  FRAGMENT_BENEF_REENVIO_SOLICITACAO = 'fragment-benef-reenvio-solicitacao',
  FRAGMENT_CONSULTA_REINCLUSAO_BENEF = 'fragment-consulta-reinclusao-benef',
  FRAGMENT_DETALHES_BENEF_LOTE = 'fragment-detalhes-benef-lote',
  FRAGMENT_EXCLUSAO_BENEFICIARIO = 'fragment-exclusao-beneficiario',
  FRAGMENT_EXCLUSAO_BENEFICIARIO_CONSULTA = 'fragment-exclusao-beneficiario-consulta',
  FRAGMENT_FATURAS = 'fragment-faturas',
  FRAGMENT_FOLHAS_PAGAMENTO = 'fragment-folhas-pagamento',
  FRAGMENT_HISTORICO_ALT_CADASTRAL = 'fragment-historico-alt-cadastral',
  FRAGMENT_HISTORICO_AUTORIZACAO = 'fragment-historico-autorizacao',
  FRAGMENT_HISTORICO_AUTORIZACAO_CONSULTA = 'fragment-historico-autorizacao-consulta',
  FRAGMENT_HISTORICO_AUTORIZACAO_CONSULTA_FROM_REQUISICAO = 'fragment-historico-autorizacao-consulta-from-requisicao',
  FRAGMENT_HISTORICO_REQUISICAO = 'fragment-historico-requisicao',
  FRAGMENT_HISTORICO_REQUISICAO_CONSULTA = 'fragment-historico-requisicao-consulta',
  FRAGMENT_HISTORICO_SOLICITACOES = 'fragment-historico-solicitacoes',
  FRAGMENT_INCLUIR_BENEF_LOTE = 'fragment-incluir-benef-lote',
  FRAGMENT_INCLUSAO_BENEFICIARIO = 'fragment-inclusao-beneficiario',
  FRAGMENT_INCLUSAO_BENEFICIARIO_NOVA_INCLUSAO = 'fragment-inclusao-beneficiario-nova-inclusao',
  FRAGMENT_INCLUSAO_BENEFICIARIO_SEQ_DETALHES = 'fragment-inclusao-beneficiario-seq-detalhes',
  FRAGMENT_INCLUSAO_BENEFICIARIO_SEQ_NOVA_INCLUSAO = 'fragment-inclusao-beneficiario-seq-nova-inclusao',
  FRAGMENT_MENSAGENS = 'fragment-mensagens',
  FRAGMENT_MENSAGENS_DETALHES = 'fragment-mensagens-detalhes',
  FRAGMENT_MENSALIDADES = 'fragment-mensalidades',
  FRAGMENT_MEUS_DADOS = 'fragment-meus-dados',
  FRAGMENT_PRIVACIDADE = 'fragment-privacidade',
  FRAGMENT_PRODUCT_CHANGE = 'fragment-product-change',
  FRAGMENT_REINCLUSAO_BENEF = 'fragment-reinclusao-benef',
  FRAGMENT_SOLICITACOES_PENDENTES = 'fragment-solicitacoes-pendentes',
  FRAGMENT_SOLICITACOES_PENDENTES_DETALHES_AUTORIZACAO = 'fragment-solicitacoes-pendentes-detalhes-autorizacao',
  FRAGMENT_SOLICITACOES_PENDENTES_DETALHES_REQUISICAO = 'fragment-solicitacoes-pendentes-detalhes-requisicao',
  FRAGMENT_TESTE = 'fragment-teste',
  HISTORICO_ATENDIMENTO_DETALHES_FRAGMENT = 'historico-atendimento-detalhes-fragment',
  HISTORICO_ATENDIMENTO_FRAGMENT = 'historico-atendimento-fragment',
  LAYOUT_ROUTES = 'layout-routes',
  LOTE_FRAGMENT = 'lote-fragment',
  LOTE_ROUTE = 'lote-route',
  MIGRACAO_CONTRATO_FRAGMENT = 'migracao-contrato-fragment',
  MOVIMENTACAO_DADOS_PESSOAIS = 'movimentacao-dados-pessoais',
  MOVIMENTACAO_LOTE_FRAGMENT = 'movimentacao-lote-fragment',
  MOVIMENTACAO_LOTE_ROUTE = 'movimentacao-lote-route',
  REDIRECT_MEUS_DADOS = 'redirect-meus-dados',
  RELATORIOS_FRAGMENT = 'relatorios-fragment',
  RELATORIOS_ROUTE = 'relatorios-route',
  ROUTE_ALTERACAO_LOCALIZACAO = 'route-alteracao-localizacao',
  ROUTE_ALTERAR_SUBESTIPULANTE = 'route-alterar-subestipulante',
  ROUTE_ANALISE_ATENDIMENTOS = 'route-analise-atendimentos',
  ROUTE_ANALISE_ATENDIMENTOS_DETALHES_AUTORIZACAO = 'route-analise-atendimentos-detalhes-autorizacao',
  ROUTE_ANALISE_ATENDIMENTOS_DETALHES_REQUISICAO = 'route-analise-atendimentos-detalhes-requisicao',
  ROUTE_BENEF_DETALHES = 'route-benef-detalhes',
  ROUTE_BENEF_INCONSISTENCIA_SIB = 'route-benef-inconsistencia-sib',
  ROUTE_BENEF_REENVIO_SOLICITACAO = 'route-benef-reenvio-solicitacao',
  ROUTE_BENEFICIARY = 'route-beneficiary',
  ROUTE_CONSULTA_REINCLUSAO_BENEF = 'route-consulta-reinclusao-benef',
  ROUTE_CONTRACT_FRAGMENT = 'route-contract-fragment',
  ROUTE_CONTRATO_DOSSIE = 'route-contrato-dossie',
  ROUTE_DETALHES_BENEF_LOTE = 'route-detalhes-benef-lote',
  ROUTE_EXCLUSAO_BENEFICIARIO = 'route-exclusao-beneficiario',
  ROUTE_EXCLUSAO_BENEFICIARIO_CONSULTA = 'route-exclusao-beneficiario-consulta',
  ROUTE_FATURAS = 'route-faturas',
  ROUTE_FOLHAS_PAGAMENTO = 'route-folhas-pagamento',
  ROUTE_HISTORICO_ATENDIMENTO = 'route-historico-atendimento',
  ROUTE_HISTORICO_ATENDIMENTO_DETALHES = 'route-historico-atendimento-detalhes',
  ROUTE_HISTORICO_AUTORIZACAO = 'route-historico-autorizacao',
  ROUTE_HISTORICO_AUTORIZACAO_CONSULTA = 'route-historico-autorizacao-consulta',
  ROUTE_HISTORICO_AUTORIZACAO_CONSULTA_FROM_REQUISICAO = 'route-historico-autorizacao-consulta-from-requisicao',
  ROUTE_HISTORICO_REQUISICAO = 'route-historico-requisicao',
  ROUTE_HISTORICO_REQUISICAO_CONSULTA = 'route-historico-requisicao-consulta',
  ROUTE_HISTORICO_SOLICITACOES = 'route-historico-solicitacoes',
  ROUTE_INCLUIR_BENEF_LOTE = 'route-incluir-benef-lote',
  ROUTE_INCLUSAO_BENEFICIARIO = 'route-inclusao-beneficiario',
  ROUTE_INCLUSAO_BENEFICIARIO_NOVA_INCLUSAO = 'route-inclusao-beneficiario-nova-inclusao',
  ROUTE_INCLUSAO_BENEFICIARIO_SEQ_DETALHES = 'route-inclusao-beneficiario-seq-detalhes',
  ROUTE_INCLUSAO_BENEFICIARIO_SEQ_NOVA_INCLUSAO = 'route-inclusao-beneficiario-seq-nova-inclusao',
  ROUTE_MENSAGENS = 'route-mensagens',
  ROUTE_MENSAGENS_DETALHES = 'route-mensagens-detalhes',
  ROUTE_MENSALIDADES = 'route-mensalidades',
  ROUTE_PRIVACIDADE = 'route-privacidade',
  ROUTE_PRODUCT_CHANGE = 'route-product-change',
  ROUTE_REINCLUSAO_BENEF = 'route-reinclusao-benef',
  ROUTE_TEST = 'route-test',
  SOLICITAR_CARTAO_FRAGMENT = 'solicitar-cartao-fragment',
  SOLICITAR_CARTAO_ROUTE = 'solicitar-cartao-route',
  SOLICITAR_REPASSE_FRAGMENT = 'solicitar-repasse-fragment',
  SOLICITAR_REPASSE_ROUTE = 'solicitar-repasse-route',
  TRANSFERIR_TITULARIDADE_FRAGMENT = 'transferir-titularidade-fragment',
  TRANSFERIR_TITULARIDADE_ROUTE = 'transferir-titularidade-route',
}
export { RoutesAliases };
